import { MachineListPanel } from '@features/Contractor/Resources'
import { createFileRoute } from '@tanstack/react-router'
import { t } from '@utils/i18n-to-migrate'

const MachinesRoute: React.FC = () => {
  const { contractorId } = Route.useParams()
  return <MachineListPanel contractorId={contractorId} />
}

export const Route = createFileRoute('/contractor/$contractorId/resources/machines')({
  component: MachinesRoute,
  staticData: {
    breadcrumb: t('contractor.profile.resources.tabs.machines'),
  },
})
